import inherits from 'inherits';

import Ids from 'ids';

import BaseViewer from './BaseViewer';

export default function BaseModeler(options) {
  BaseViewer.call(this, options);

  this.on('import.parse.complete', function(event) {
    if (!event.error) {
      this._collectIds(event.definitions, event.elementsById);
    }
  }, this);

  this.on('diagram.destroy', function() {
    this.get('moddle').ids.clear();
  }, this);
}

inherits(BaseModeler, BaseViewer);

BaseModeler.prototype._createModdle = function(options) {
  var moddle = BaseViewer.prototype._createModdle.call(this, options);

  moddle.ids = new Ids([ 32, 36, 1 ]);

  return moddle;
};

BaseModeler.prototype._collectIds = function(definitions, elementsById) {

  var moddle = definitions.$model,
      ids = moddle.ids,
      id;

  ids.clear();

  for (id in elementsById) {
    ids.claim(id, elementsById[id]);
  }
};
